module.exports = __webpack_public_path__ + "img/plus-icon.43474147.svg";